import { render, staticRenderFns } from "./ProductMetaFilterGroupFields.vue?vue&type=template&id=4e3704f6&scoped=true"
import script from "./ProductMetaFilterGroupFields.vue?vue&type=script&lang=js"
export * from "./ProductMetaFilterGroupFields.vue?vue&type=script&lang=js"
import style0 from "./ProductMetaFilterGroupFields.vue?vue&type=style&index=0&id=4e3704f6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3704f6",
  null
  
)

export default component.exports